import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/features/auth/AuthProvider';

/** Login: si ya hay sesión, redirige al inicio. */
export function PublicRoute() {
    const { user, checkSession } = useAuth();
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let cancelled = false;
        void checkSession().then(() => {
            if (!cancelled) setReady(true);
        });
        return () => {
            cancelled = true;
        };
    }, [checkSession]);

    if (!ready) {
        return (
            <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', minHeight: '100dvh' }}>
                <div className="spinner" aria-label="Cargando" />
            </div>
        );
    }

    if (user) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
}
